import { createFileRoute, redirect } from "@tanstack/react-router";
import type { RouterContext } from "@/lib/router-context";

export const Route = createFileRoute("/")({
  beforeLoad: async ({ context }) => {
    const ctx = context as RouterContext;
    const session = await ctx.ensureSession();
    if (session) {
      throw redirect({ to: "/dashboard" });
    }
    throw redirect({ to: "/auth" });
  },
  component: () => null
});
